import { object, string } from 'yup';

const formsTagValidation = object().shape({
  name: string().required('validations.tag_name.required'),
  type: string().required('validations.type.required'),
});

export default formsTagValidation;
